let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1toGC")).then(() => parcelRequire('c70Lr'));